import React from 'react'
import { Form } from 'react-bootstrap'


const TextareaComponent = ({
	control,
	disabled=false,
	errors,
	label=null,
	name,
	placeholder=null,
	register,
	required=true,
	rows=3,
	...rest
}) => {

	return (
		<>

			<Form.Group className='mb-3'>
				{label && 
					<Form.Label
						className='mb-0'
						htmlFor={name}
					>{label}</Form.Label>
				}

				<Form.Control 
					className='form-control'
					disabled={disabled}
					id={name}
					name={name}
					placeholder={placeholder}
					as='textarea'
					rows={rows}
					{...register(name, {
						required: {
							value: required,
							message: 'Campo obrigatório'
						}
					})}
					{...rest}
				/>

				{errors[name] && <p className='mt-1 form-error'>{errors[name].message}</p>}
			</Form.Group>

		</>
	)

}

export default TextareaComponent;
